import Onsite from './onsite'

export default {
    bootstrap (mock) {
        Onsite.bootstrap(mock)
    }
}